import React from "react";
import { Image, Form, Icon } from "semantic-ui-react";
import personImg from "../../common/person.png";
import { convertToBEDate } from "../../../utils/tsUtils";
import { downloadOrOpenFile, isValidHttpUrl } from "./MyMessage";

import DialogMessage from "./DialogMessage";
import MessageContentHTML from "./MessageContentHTML";
import DisplayContentImage from "./DisplayContentImage";
import DisplayContentFile from "./DisplayContentFile";
import ButtonDownloadFile from "./ButtonDownloadFile";
import ChatVideoContent from "./ChatVideoContent";
import moment from "moment";

interface FriendMessageProps {
  avatarBotUrlString?: string;
  isBot?: boolean;
  isMobile?: boolean;
  onOpenVideoCall?: () => void;
  onNavigationMessage?: () => void;
  getLastMessage?: () => void;
  acceptContentHTML?: boolean;
  onClickLink?: () => void;
  icon?: string;
  downloadFile?: boolean;
  showFileSize?: boolean;
  isMediaViewer?: boolean;
  language?: string;
  onLoadImage?: (id: any) => void;
}

const DEFAULT_PROPS = {
  avatarBotUrlString: "",
  isBot: false,
  isMobile: false,
  onOpenVideoCall: ({ url }) => {},
  onNavigationMessage: ({ content = "" }) => content,
  onMobileOpenImage: () => {},
  getLastMessage: () => {},
  acceptContentHTML: false,
  onClickLink: () => {},
  icon: "",
  downloadFile: false,
  language: "th-TH",
};

const FriendMessage = (propsParam: FriendMessageProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(
      Object.entries(propsParam).filter(([_, value]) => value !== undefined)
    ),
  };

  const dateFormat = "DD/MM/YYYY";
  // console.log(" FriendMessage ", props)
  const createMessage = () => {
    if (props.message.content_type === "file") {
      return (
        <DisplayContentFile
          content={props.message.content}
          file={props.message.content_file}
          isMediaViewer={props.isMediaViewer}
          showFileSize={props.showFileSize}
        />
      );
    } else if (props.message.content_type === "image") {
      return (
        <DisplayContentImage
          id={props.message.id}
          isMediaViewer={props.isMediaViewer}
          isMobile={props.isMobile}
          src={props.message.content_file}
          onLoadImage={props.onLoadImage}
        />
      );
    } else if (props.message.content_type === "video") {
      if (!props.message.content_file) {
        return "Unable to get video";
      }

      return (
        <ChatVideoContent
          file={props.message.content_file}
        />
      );
    } else if (props.message.content_type === "vid_call") {
      return <Icon name="call square" size="big" color="green" />;
    } else if (props.message.content_type === "end_call") {
      return <Icon name="call square" size="big" color="gray" />;
    } else if (props.message.content_type === "navigation") {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        channelId: props.message.channel,
      });
    } else if (["bill", "shipping"].includes(props.message.content_type)) {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
        channelId: props.message.channel,
      });
    } else if (
      [
        "patient_appointment",
        "patient-appointment-update",
        "diag_rule",
      ].includes(props.message.content_type)
    ) {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
        channelId: props.message.channel,
      });
    } else if (props.message.content_type === "dialog_box") {
      return (
        <DialogMessage
          content={props.message.content}
          contentPayload={props.message.content_payload}
          getLastMessage={props.getLastMessage}
        />
      );
    } else if (props.message.content_type === "html") {
      return <MessageContentHTML content={props.message.content} />;
    } else {
      // text_hyper_link is custom type for teleDesktop
      if (props.message.content.includes("http") &&
          props.message.content.includes("/form/") &&
          !props.isMobile) {
        return props.onNavigationMessage({
          content: props.message.content,
          contentPayload: props.message.content_payload,
          contentType: "text_hyper_link",
        });
      } else if (
        props.acceptContentHTML &&
        props.message.content?.trim().startsWith("<div") &&
        props.message.content?.trim().endsWith("</div>")
      ) {
        // It's bot
        // console.log("props.message.content", props.message.content);
        return (
          <div
            style={{ color: "#4f4f4f" }}
            dangerouslySetInnerHTML={{ __html: props.message.content }}
          />
        );
      } else {
        // Not Bot
        if (props.message.content.includes("http")) {
          let listMsg = props.message.content.split(" ");
          // console.log("listMsg", listMsg);
          let Linkify = listMsg.map((item: any) => {
            // console.log("listMsg item: ", item)
            if (!item.startsWith("http") && item.includes("http")) {
              let startIdx = item.indexOf("http");
              // console.log("listMsg startIdx: ", startIdx)
              if (startIdx > 0) {
                let normalText = item.slice(0, startIdx);
                // console.log("normalText:", normalText);
                let urlText = item.slice(startIdx);
                // console.log("urlText:", urlText);

                // workaround issue 52375
                var urlLinkText = item;
                if (isValidHttpUrl(item)) {
                  var prepareUrl = new URL(item);
                  if (prepareUrl.host === "penguin.ishealth.app") {
                    prepareUrl.host = "mybplus.web.app";
                    urlLinkText = prepareUrl.toString() + "/?app=IH";
                  } else if (
                    prepareUrl.host === "staging.penguin.ishealth.app"
                  ) {
                    prepareUrl.host = "bplus-expansion-staging.web.app/";
                    urlLinkText = prepareUrl.toString() + "/?app=IH";
                  }
                  // console.log(" urlLinkText", urlLinkText)
                }

                return (
                  <>
                    <>
                      {normalText}

                      <a
                        href={urlLinkText}
                        style={{ position: "relative" }}
                        onClick={props.onClickLink}
                        onMouseDown={props.onClickLink}
                        onContextMenu={props.onClickLink}
                      >
                        {urlLinkText}
                      </a>
                    </>
                  </>
                );
              }
            }
              // console.log("item: ", item)
              // workaround issue 52375
              urlLinkText = item;
              if (isValidHttpUrl(item)) {
                prepareUrl = new URL(item);
                if (prepareUrl.host === "penguin.ishealth.app") {
                  prepareUrl.host = "mybplus.web.app";
                  urlLinkText = prepareUrl.toString() + "/?app=IH";
                } else if (prepareUrl.host === "staging.penguin.ishealth.app") {
                  prepareUrl.host = "bplus-expansion-staging.web.app/";
                  // prepareUrl.host = "192.168.11.206:3000/"
                  urlLinkText = prepareUrl.toString() + "/?app=IH";
              }
              // console.log(" urlLinkText", urlLinkText)
            }

              return isValidHttpUrl(item) ? (
                <a
                  href={urlLinkText}
                  style={{ position: "relative" }}
                  onClick={props.onClickLink}
                  onMouseDown={props.onClickLink}
                  onContextMenu={props.onClickLink}
                >
                  {" "}
                  {urlLinkText}{" "}
                </a>
              ) : (
                <> {item} </>
              );

          });

          return Linkify;
        } else {
          return props.message.content;
        }
      }
    }
  };

  return (
    <Form className="FriendMessage">
      {!props.isBot && props.message.author ? (
        props.icon !== "" ? (
          <Form.Field className="friendName_icon">
            <div
              style={{
                background: "#ffffff",
                borderRadius: "20px",
                padding: "5px",
              }}
            >
              <Image
                src={props.icon ? props.icon : personImg}
                style={{ width: "25px", height: "25px" }}
                circular
                // onMouseOver={() => console.log(9999)}
              />
            </div>
            <b style={{ marginLeft: "5px" }}>{props.message.author.full_name}</b>
          </Form.Field>
        ) : (
          <Form.Field className="friendName">
            <b>{props.message.author.full_name}</b>
          </Form.Field>
        )
      ) : null}

      <Form.Group
        inline
        style={{
          alignItems: "flex-start",
          flexWrap: "nowrap",
          flexDirection: "row",
        }}
      >
        {!props.isBot && (
          <Form.Field width={1} className="avatarImage">
            <Image
              src={
                props.message.author && props.message.author.image
                  ? props.message.author.image
                  : personImg
              }
              circular
              size="mini"
              // onMouseOver={() => console.log(9999)}
            />
          </Form.Field>
        )}

        {props.isBot && (
          <Form.Field
            style={{
              maxWidth: "50px",
              minWidth: "50px",
              padding: "0px 4px 0px 0px",
            }}
          >
            <Image src={props.avatarBotUrlString} circular />
          </Form.Field>
        )}

        <Form.Field
          className={"content" + (props.isBot ? " chatbot" : "")}
          {...(props.isMobile &&
            props.message.content_type === "file" && {
              href: props.message.content_file,
            })}
          onClick={() => {
            if (props.message.content_type == "vid_call" && !props.isMobile) {
              props.onOpenVideoCall({ url: props.message.content });
            }
            if (props.message.content_type === "file") {
              downloadOrOpenFile({ downloadFile: props.downloadFile, ...props.message });
            }
            if (props.isMobile && props.message.content_type === "image") {
              props.onMobileOpenImage(props.message.content_file);
            }
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "0.3rem",
            }}
          >
            <div
              className="bubble"
              style={{
                ...(props.message.content_type === "patient_appointment" && {
                  maxWidth: "80%",
                }),
                maxWidth: "500px",
              }}
            >
              {createMessage()}
            </div>
            <div className="sendDateTime">
              <div> {props.message.send_at.split(" ")[1]}</div>
              <div>
                {" "}
                {props.language === "th-TH"
                  ? convertToBEDate({
                      date: props.message.send_at.split(" ")[0],
                    })
                  : moment(props.message.send_at.split(" ")[0], dateFormat).format(dateFormat)}{" "}
              </div>
            </div>
          </div>
        </Form.Field>
      </Form.Group>
      <ButtonDownloadFile
        style={{ direction: "ltr", marginTop: "-0.85rem" }}
        content={props.message.content}
        contentFile={props.message.content_file}
        contentType={props.message.content_type}
        showFileSize={props.showFileSize}
      />
    </Form>
  );
};

export default React.memo(FriendMessage);
